var _path, _path2, _path3, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgAchievement = function SvgAchievement(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 76,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.717.802a5.989 5.989 0 015.989 0l27.722 16.006a5.989 5.989 0 012.995 5.186v32.012a5.989 5.989 0 01-2.995 5.186L38.706 75.198a5.989 5.989 0 01-5.989 0L4.994 59.192A5.989 5.989 0 012 54.006V21.994a5.989 5.989 0 012.994-5.186L32.717.802z",
    fill: "#6E6E6E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1 2.76a5.674 5.674 0 015.674 0l26.263 15.163a5.673 5.673 0 012.837 4.914v30.326c0 2.027-1.081 3.9-2.837 4.914L38.774 73.24a5.673 5.673 0 01-5.674 0L6.837 58.077A5.673 5.673 0 014 53.163V22.837c0-2.027 1.081-3.9 2.837-4.914L33.1 2.76z",
    fill: "#3B3B3B"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 2,
    width: 64,
    height: 72
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1 2.76a5.674 5.674 0 015.674 0l26.263 15.163a5.673 5.673 0 012.837 4.914v30.326c0 2.027-1.081 3.9-2.837 4.914L38.774 73.24a5.673 5.673 0 01-5.674 0L6.837 58.077A5.673 5.673 0 014 53.163V22.837c0-2.027 1.081-3.9 2.837-4.914L33.1 2.76z",
    fill: "#8BBCE7"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.305 39.244l-2.738 1.397.523-2.96-2.216-2.095 3.062-.432 1.369-2.693 1.37 2.693 3.06.432-2.215 2.096.523 2.96-2.738-1.398zM36.228 14.321l-2.738 1.397.523-2.96-2.216-2.095 3.062-.432 1.37-2.693 1.368 2.693 3.062.432-2.215 2.096.523 2.96-2.739-1.398zM61.151 39.244l-2.738 1.397.523-2.96-2.216-2.095 3.062-.432 1.369-2.693 1.37 2.693 3.06.432-2.215 2.096.523 2.96-2.738-1.398z",
    fill: "#FFC62E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.91 34.087l14.83 8.562-11.552 20.009a.554.554 0 01-.974-.028l-3.86-7.647h-9.548a.554.554 0 01-.48-.83L25.91 34.087z",
    fill: "#FEBE10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.03 38.175l10.037 5.795L28.9 58.113l-2.925-5.795h-7.111l8.165-14.143z",
    fill: "#F9600A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.961 42.649l14.83-8.562 11.552 20.009a.554.554 0 01-.511.83l-8.553-.48-4.774 8.268a.554.554 0 01-.96 0L30.962 42.65z",
    fill: "#FEBE10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.997 43.97l10.036-5.795L53.2 52.318l-6.481-.364-3.556 6.158-8.165-14.142z",
    fill: "#F9600A"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 36.339,
    fill: "#FFC62E",
    r: 15.508
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35.745,
    cy: 36.339,
    r: 12.185,
    fill: "#FFF3D4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.115 40.16l-4.45 2.27.85-4.808-3.6-3.406 4.976-.702 2.224-4.376 2.225 4.376 4.975.702-3.6 3.406.85 4.809-4.45-2.27z",
    fill: "#FFC62E"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgAchievement);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "achievement.b62bf028a9539902dc736c10ecea0336.svg";